module.exports = "<angular2-multiselect *ngIf=\"availableTags\" [data]=\"availableTags\" [(ngModel)]=\"selectedTags\"\r\n\t\t\t\t\t\t\t [settings]=\"dropdownSettings\"\r\n\t\t\t\t\t\t\t (onSelect)=\"onItemSelect($event)\"\r\n\t\t\t\t\t\t\t (onDeSelect)=\"OnItemDeSelect($event)\"\r\n\t\t\t\t\t\t\t (onSelectAll)=\"onSelectAll($event)\"\r\n\t\t\t\t\t\t\t (onDeSelectAll)=\"onDeSelectAll($event)\"></angular2-multiselect>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/file/tag-selector.component.html
// module id = 437
// module chunks = 10